import { useInfiniteQuery } from '@tanstack/react-query';
import { jsonHeaders } from '#lib/helpers/fetch.js';
import { getAuthHeader } from '#lib/hooks/use-auth.jsx';

async function fetchOrders(params) {
    const authHeaders = await getAuthHeader();
    const queryString = new URLSearchParams(params);
    const response = await fetch(`${API_URL}/p/import?${queryString.toString()}`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });

    return await response.json();
}

export function useRetrieve(params) {
    const { data, ...queryProps } = useInfiniteQuery({
        queryKey: ['bookings', params.queryText, params.serviceStart, params.serviceEnd],
        queryFn: ({ pageParam = params }) => fetchOrders(pageParam),
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    return {
        data,
        ...queryProps
    };
}
